
import React from 'react';

export const FONT_FAMILIES = [
  { label: 'Sans Serif', value: 'font-sans' },
  { label: 'Monospace', value: 'font-mono' },
  { label: 'Serif', value: 'font-serif' },
];

export const CORNER_STYLES = [
  { label: 'Rounded', value: 'rounded' },
  { label: 'Sharp', value: 'sharp' },
];

export const THEMES = [
  { label: 'Light', value: 'light' },
  { label: 'Dark', value: 'dark' },
  { label: 'System', value: 'system' },
];
